(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var THROW_ISE = kotlin_kotlin.$_$.d1;
  var Unit_getInstance = kotlin_kotlin.$_$.d;
  var Enum = kotlin_kotlin.$_$.a1;
  var protoOf = kotlin_kotlin.$_$.r;
  var defineProp = kotlin_kotlin.$_$.h;
  var VOID = kotlin_kotlin.$_$.f1;
  var classMeta = kotlin_kotlin.$_$.f;
  var setMetadataFor = kotlin_kotlin.$_$.s;
  var objectMeta = kotlin_kotlin.$_$.q;
  var IntCompanionObject_getInstance = kotlin_kotlin.$_$.c;
  var hashCode = kotlin_kotlin.$_$.k;
  var THROW_CCE = kotlin_kotlin.$_$.c1;
  var equals = kotlin_kotlin.$_$.i;
  //endregion
  //region block: pre-declaration
  setMetadataFor(CurrencyRepresentationOption, 'CurrencyRepresentationOption', classMeta, Enum);
  setMetadataFor(DenominationOption, 'DenominationOption', classMeta);
  setMetadataFor(Cents, 'Cents', objectMeta, DenominationOption);
  setMetadataFor(Dollars, 'Dollars', classMeta, DenominationOption);
  setMetadataFor(DollarsAndCents, 'DollarsAndCents', classMeta, DenominationOption);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(FractionDigitsStrategy, 'FractionDigitsStrategy', classMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(MoneyFormatterConfig, 'MoneyFormatterConfig', classMeta);
  setMetadataFor(NumberFormat, 'NumberFormat', classMeta);
  setMetadataFor(Full, 'Full', objectMeta, NumberFormat);
  setMetadataFor(Abbreviated, 'Abbreviated', classMeta, NumberFormat);
  setMetadataFor(RoundingMode, 'RoundingMode', classMeta, Enum);
  setMetadataFor(SignOption, 'SignOption', classMeta, Enum);
  setMetadataFor(TrailingZeroesBehavior, 'TrailingZeroesBehavior', classMeta, Enum);
  setMetadataFor(UnitMagnitudeFormat, 'UnitMagnitudeFormat', classMeta, Enum);
  setMetadataFor(ZeroBiasOption, 'ZeroBiasOption', classMeta, Enum);
  //endregion
  var CurrencyRepresentationOption_NARROW_SYMBOL_instance;
  var CurrencyRepresentationOption_CODE_instance;
  var CurrencyRepresentationOption_NARROW_SYMBOL_AND_CODE_instance;
  var CurrencyRepresentationOption_CENT_NAME_instance;
  var CurrencyRepresentationOption_NONE_instance;
  function values() {
    return [CurrencyRepresentationOption_NARROW_SYMBOL_getInstance(), CurrencyRepresentationOption_CODE_getInstance(), CurrencyRepresentationOption_NARROW_SYMBOL_AND_CODE_getInstance(), CurrencyRepresentationOption_CENT_NAME_getInstance(), CurrencyRepresentationOption_NONE_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'NARROW_SYMBOL':
        return CurrencyRepresentationOption_NARROW_SYMBOL_getInstance();
      case 'CODE':
        return CurrencyRepresentationOption_CODE_getInstance();
      case 'NARROW_SYMBOL_AND_CODE':
        return CurrencyRepresentationOption_NARROW_SYMBOL_AND_CODE_getInstance();
      case 'CENT_NAME':
        return CurrencyRepresentationOption_CENT_NAME_getInstance();
      case 'NONE':
        return CurrencyRepresentationOption_NONE_getInstance();
      default:
        CurrencyRepresentationOption_initEntries();
        THROW_ISE();
        break;
    }
  }
  var CurrencyRepresentationOption_entriesInitialized;
  function CurrencyRepresentationOption_initEntries() {
    if (CurrencyRepresentationOption_entriesInitialized)
      return Unit_getInstance();
    CurrencyRepresentationOption_entriesInitialized = true;
    CurrencyRepresentationOption_NARROW_SYMBOL_instance = new CurrencyRepresentationOption('NARROW_SYMBOL', 0);
    CurrencyRepresentationOption_CODE_instance = new CurrencyRepresentationOption('CODE', 1);
    CurrencyRepresentationOption_NARROW_SYMBOL_AND_CODE_instance = new CurrencyRepresentationOption('NARROW_SYMBOL_AND_CODE', 2);
    CurrencyRepresentationOption_CENT_NAME_instance = new CurrencyRepresentationOption('CENT_NAME', 3);
    CurrencyRepresentationOption_NONE_instance = new CurrencyRepresentationOption('NONE', 4);
  }
  function CurrencyRepresentationOption(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CurrencyRepresentationOption_NARROW_SYMBOL_getInstance() {
    CurrencyRepresentationOption_initEntries();
    return CurrencyRepresentationOption_NARROW_SYMBOL_instance;
  }
  function CurrencyRepresentationOption_CODE_getInstance() {
    CurrencyRepresentationOption_initEntries();
    return CurrencyRepresentationOption_CODE_instance;
  }
  function CurrencyRepresentationOption_NARROW_SYMBOL_AND_CODE_getInstance() {
    CurrencyRepresentationOption_initEntries();
    return CurrencyRepresentationOption_NARROW_SYMBOL_AND_CODE_instance;
  }
  function CurrencyRepresentationOption_CENT_NAME_getInstance() {
    CurrencyRepresentationOption_initEntries();
    return CurrencyRepresentationOption_CENT_NAME_instance;
  }
  function CurrencyRepresentationOption_NONE_getInstance() {
    CurrencyRepresentationOption_initEntries();
    return CurrencyRepresentationOption_NONE_instance;
  }
  function Cents() {
    Cents_instance = this;
    DenominationOption.call(this);
  }
  var Cents_instance;
  function Cents_getInstance() {
    if (Cents_instance == null)
      new Cents();
    return Cents_instance;
  }
  function Dollars(roundingMode) {
    roundingMode = roundingMode === VOID ? RoundingMode_HALF_UP_getInstance() : roundingMode;
    DenominationOption.call(this);
    this.roundingMode = roundingMode;
  }
  protoOf(Dollars).g7 = function () {
    return this.roundingMode;
  };
  function DollarsAndCents(omitsCentsIfPossible, showsAsCentsIfPossible, trailingZeroesBehavior) {
    trailingZeroesBehavior = trailingZeroesBehavior === VOID ? null : trailingZeroesBehavior;
    DenominationOption.call(this);
    this.omitsCentsIfPossible = omitsCentsIfPossible;
    this.showsAsCentsIfPossible = showsAsCentsIfPossible;
    this.trailingZeroesBehavior = trailingZeroesBehavior;
  }
  protoOf(DollarsAndCents).h7 = function () {
    return this.omitsCentsIfPossible;
  };
  protoOf(DollarsAndCents).i7 = function () {
    return this.showsAsCentsIfPossible;
  };
  protoOf(DollarsAndCents).j7 = function () {
    return this.trailingZeroesBehavior;
  };
  function DenominationOption() {
  }
  function Companion() {
    Companion_instance = this;
    this.UP_TO_ONE = new FractionDigitsStrategy(0, 1, IntCompanionObject_getInstance().MAX_VALUE);
    this.EXACTLY_TWO = new FractionDigitsStrategy(2, 2, IntCompanionObject_getInstance().MAX_VALUE);
    this.BALANCED = new FractionDigitsStrategy(0, 2, 4);
  }
  protoOf(Companion).k7 = function () {
    return this.UP_TO_ONE;
  };
  protoOf(Companion).l7 = function () {
    return this.EXACTLY_TWO;
  };
  protoOf(Companion).m7 = function () {
    return this.BALANCED;
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function FractionDigitsStrategy(minimumFractionDigits, maximumFractionDigits, maximumTotalDigits) {
    Companion_getInstance();
    this.minimumFractionDigits = minimumFractionDigits;
    this.maximumFractionDigits = maximumFractionDigits;
    this.maximumTotalDigits = maximumTotalDigits;
  }
  protoOf(FractionDigitsStrategy).n7 = function () {
    return this.minimumFractionDigits;
  };
  protoOf(FractionDigitsStrategy).o7 = function () {
    return this.maximumFractionDigits;
  };
  protoOf(FractionDigitsStrategy).p7 = function () {
    return this.maximumTotalDigits;
  };
  function Companion_0() {
    Companion_instance_0 = this;
    this.STANDARD = new MoneyFormatterConfig(Full_getInstance(), CurrencyRepresentationOption_NARROW_SYMBOL_getInstance(), new DollarsAndCents(false, false), SignOption_STANDARD_getInstance(), ZeroBiasOption_NONE_getInstance());
    this.ACCOUNTING = new MoneyFormatterConfig(Full_getInstance(), CurrencyRepresentationOption_NARROW_SYMBOL_getInstance(), new DollarsAndCents(false, false), SignOption_ACCOUNTING_getInstance(), ZeroBiasOption_NONE_getInstance());
    this.CODE = new MoneyFormatterConfig(Full_getInstance(), CurrencyRepresentationOption_CODE_getInstance(), new DollarsAndCents(false, false), SignOption_STANDARD_getInstance(), ZeroBiasOption_NONE_getInstance());
    this.COMPACT = new MoneyFormatterConfig(Full_getInstance(), CurrencyRepresentationOption_NARROW_SYMBOL_getInstance(), new DollarsAndCents(true, false), SignOption_STANDARD_getInstance(), ZeroBiasOption_NONE_getInstance());
    this.COMPACT_CODE = new MoneyFormatterConfig(Full_getInstance(), CurrencyRepresentationOption_CODE_getInstance(), new DollarsAndCents(true, false), SignOption_STANDARD_getInstance(), ZeroBiasOption_NONE_getInstance());
    this.COMPACT_POSITIVE_SIGN_ONLY = new MoneyFormatterConfig(Full_getInstance(), CurrencyRepresentationOption_NARROW_SYMBOL_getInstance(), new DollarsAndCents(true, false), SignOption_POSITIVE_ONLY_getInstance(), ZeroBiasOption_NONE_getInstance());
    this.COMPACT_SYMBOL_AND_CODE = new MoneyFormatterConfig(Full_getInstance(), CurrencyRepresentationOption_NARROW_SYMBOL_AND_CODE_getInstance(), new DollarsAndCents(true, false), SignOption_STANDARD_getInstance(), ZeroBiasOption_NONE_getInstance());
    this.CENTS = new MoneyFormatterConfig(Full_getInstance(), CurrencyRepresentationOption_CENT_NAME_getInstance(), Cents_getInstance(), SignOption_STANDARD_getInstance(), ZeroBiasOption_NONE_getInstance());
  }
  protoOf(Companion_0).q7 = function () {
    return this.STANDARD;
  };
  protoOf(Companion_0).r7 = function () {
    return this.ACCOUNTING;
  };
  protoOf(Companion_0).s7 = function () {
    return this.CODE;
  };
  protoOf(Companion_0).t7 = function () {
    return this.COMPACT;
  };
  protoOf(Companion_0).u7 = function () {
    return this.COMPACT_CODE;
  };
  protoOf(Companion_0).v7 = function () {
    return this.COMPACT_POSITIVE_SIGN_ONLY;
  };
  protoOf(Companion_0).w7 = function () {
    return this.COMPACT_SYMBOL_AND_CODE;
  };
  protoOf(Companion_0).x7 = function () {
    return this.CENTS;
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function MoneyFormatterConfig(numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption) {
    Companion_getInstance_0();
    this.numberFormat = numberFormat;
    this.currencyRepresentationOption = currencyRepresentationOption;
    this.denominationOption = denominationOption;
    this.signOption = signOption;
    this.zeroBiasOption = zeroBiasOption;
  }
  protoOf(MoneyFormatterConfig).y7 = function () {
    return this.numberFormat;
  };
  protoOf(MoneyFormatterConfig).z7 = function () {
    return this.currencyRepresentationOption;
  };
  protoOf(MoneyFormatterConfig).a8 = function () {
    return this.denominationOption;
  };
  protoOf(MoneyFormatterConfig).b8 = function () {
    return this.signOption;
  };
  protoOf(MoneyFormatterConfig).c8 = function () {
    return this.zeroBiasOption;
  };
  protoOf(MoneyFormatterConfig).d8 = function () {
    return this.numberFormat;
  };
  protoOf(MoneyFormatterConfig).e8 = function () {
    return this.currencyRepresentationOption;
  };
  protoOf(MoneyFormatterConfig).f8 = function () {
    return this.denominationOption;
  };
  protoOf(MoneyFormatterConfig).g8 = function () {
    return this.signOption;
  };
  protoOf(MoneyFormatterConfig).h8 = function () {
    return this.zeroBiasOption;
  };
  protoOf(MoneyFormatterConfig).i8 = function (numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption) {
    return new MoneyFormatterConfig(numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption);
  };
  protoOf(MoneyFormatterConfig).copy = function (numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption, $super) {
    numberFormat = numberFormat === VOID ? this.numberFormat : numberFormat;
    currencyRepresentationOption = currencyRepresentationOption === VOID ? this.currencyRepresentationOption : currencyRepresentationOption;
    denominationOption = denominationOption === VOID ? this.denominationOption : denominationOption;
    signOption = signOption === VOID ? this.signOption : signOption;
    zeroBiasOption = zeroBiasOption === VOID ? this.zeroBiasOption : zeroBiasOption;
    return this.i8(numberFormat, currencyRepresentationOption, denominationOption, signOption, zeroBiasOption);
  };
  protoOf(MoneyFormatterConfig).toString = function () {
    return 'MoneyFormatterConfig(numberFormat=' + this.numberFormat + ', currencyRepresentationOption=' + this.currencyRepresentationOption + ', denominationOption=' + this.denominationOption + ', signOption=' + this.signOption + ', zeroBiasOption=' + this.zeroBiasOption + ')';
  };
  protoOf(MoneyFormatterConfig).hashCode = function () {
    var result = hashCode(this.numberFormat);
    result = imul(result, 31) + this.currencyRepresentationOption.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.denominationOption) | 0;
    result = imul(result, 31) + this.signOption.hashCode() | 0;
    result = imul(result, 31) + this.zeroBiasOption.hashCode() | 0;
    return result;
  };
  protoOf(MoneyFormatterConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MoneyFormatterConfig))
      return false;
    var tmp0_other_with_cast = other instanceof MoneyFormatterConfig ? other : THROW_CCE();
    if (!equals(this.numberFormat, tmp0_other_with_cast.numberFormat))
      return false;
    if (!this.currencyRepresentationOption.equals(tmp0_other_with_cast.currencyRepresentationOption))
      return false;
    if (!equals(this.denominationOption, tmp0_other_with_cast.denominationOption))
      return false;
    if (!this.signOption.equals(tmp0_other_with_cast.signOption))
      return false;
    if (!this.zeroBiasOption.equals(tmp0_other_with_cast.zeroBiasOption))
      return false;
    return true;
  };
  function Full() {
    Full_instance = this;
    NumberFormat.call(this);
  }
  var Full_instance;
  function Full_getInstance() {
    if (Full_instance == null)
      new Full();
    return Full_instance;
  }
  function Abbreviated(roundingMode, fractionDigitsStrategy, unitMagnitudeFormat) {
    NumberFormat.call(this);
    this.roundingMode = roundingMode;
    this.fractionDigitsStrategy = fractionDigitsStrategy;
    this.unitMagnitudeFormat = unitMagnitudeFormat;
  }
  protoOf(Abbreviated).g7 = function () {
    return this.roundingMode;
  };
  protoOf(Abbreviated).j8 = function () {
    return this.fractionDigitsStrategy;
  };
  protoOf(Abbreviated).k8 = function () {
    return this.unitMagnitudeFormat;
  };
  function NumberFormat() {
  }
  var RoundingMode_UP_instance;
  var RoundingMode_DOWN_instance;
  var RoundingMode_CEILING_instance;
  var RoundingMode_FLOOR_instance;
  var RoundingMode_HALF_UP_instance;
  var RoundingMode_HALF_DOWN_instance;
  var RoundingMode_HALF_EVEN_instance;
  function values_0() {
    return [RoundingMode_UP_getInstance(), RoundingMode_DOWN_getInstance(), RoundingMode_CEILING_getInstance(), RoundingMode_FLOOR_getInstance(), RoundingMode_HALF_UP_getInstance(), RoundingMode_HALF_DOWN_getInstance(), RoundingMode_HALF_EVEN_getInstance()];
  }
  function valueOf_0(value) {
    switch (value) {
      case 'UP':
        return RoundingMode_UP_getInstance();
      case 'DOWN':
        return RoundingMode_DOWN_getInstance();
      case 'CEILING':
        return RoundingMode_CEILING_getInstance();
      case 'FLOOR':
        return RoundingMode_FLOOR_getInstance();
      case 'HALF_UP':
        return RoundingMode_HALF_UP_getInstance();
      case 'HALF_DOWN':
        return RoundingMode_HALF_DOWN_getInstance();
      case 'HALF_EVEN':
        return RoundingMode_HALF_EVEN_getInstance();
      default:
        RoundingMode_initEntries();
        THROW_ISE();
        break;
    }
  }
  var RoundingMode_entriesInitialized;
  function RoundingMode_initEntries() {
    if (RoundingMode_entriesInitialized)
      return Unit_getInstance();
    RoundingMode_entriesInitialized = true;
    RoundingMode_UP_instance = new RoundingMode('UP', 0);
    RoundingMode_DOWN_instance = new RoundingMode('DOWN', 1);
    RoundingMode_CEILING_instance = new RoundingMode('CEILING', 2);
    RoundingMode_FLOOR_instance = new RoundingMode('FLOOR', 3);
    RoundingMode_HALF_UP_instance = new RoundingMode('HALF_UP', 4);
    RoundingMode_HALF_DOWN_instance = new RoundingMode('HALF_DOWN', 5);
    RoundingMode_HALF_EVEN_instance = new RoundingMode('HALF_EVEN', 6);
  }
  function RoundingMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RoundingMode_UP_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_UP_instance;
  }
  function RoundingMode_DOWN_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_DOWN_instance;
  }
  function RoundingMode_CEILING_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_CEILING_instance;
  }
  function RoundingMode_FLOOR_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_FLOOR_instance;
  }
  function RoundingMode_HALF_UP_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_HALF_UP_instance;
  }
  function RoundingMode_HALF_DOWN_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_HALF_DOWN_instance;
  }
  function RoundingMode_HALF_EVEN_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_HALF_EVEN_instance;
  }
  var SignOption_STANDARD_instance;
  var SignOption_ALWAYS_SIGNED_instance;
  var SignOption_POSITIVE_ONLY_instance;
  var SignOption_ACCOUNTING_instance;
  var SignOption_NONE_instance;
  function values_1() {
    return [SignOption_STANDARD_getInstance(), SignOption_ALWAYS_SIGNED_getInstance(), SignOption_POSITIVE_ONLY_getInstance(), SignOption_ACCOUNTING_getInstance(), SignOption_NONE_getInstance()];
  }
  function valueOf_1(value) {
    switch (value) {
      case 'STANDARD':
        return SignOption_STANDARD_getInstance();
      case 'ALWAYS_SIGNED':
        return SignOption_ALWAYS_SIGNED_getInstance();
      case 'POSITIVE_ONLY':
        return SignOption_POSITIVE_ONLY_getInstance();
      case 'ACCOUNTING':
        return SignOption_ACCOUNTING_getInstance();
      case 'NONE':
        return SignOption_NONE_getInstance();
      default:
        SignOption_initEntries();
        THROW_ISE();
        break;
    }
  }
  var SignOption_entriesInitialized;
  function SignOption_initEntries() {
    if (SignOption_entriesInitialized)
      return Unit_getInstance();
    SignOption_entriesInitialized = true;
    SignOption_STANDARD_instance = new SignOption('STANDARD', 0);
    SignOption_ALWAYS_SIGNED_instance = new SignOption('ALWAYS_SIGNED', 1);
    SignOption_POSITIVE_ONLY_instance = new SignOption('POSITIVE_ONLY', 2);
    SignOption_ACCOUNTING_instance = new SignOption('ACCOUNTING', 3);
    SignOption_NONE_instance = new SignOption('NONE', 4);
  }
  function SignOption(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SignOption_STANDARD_getInstance() {
    SignOption_initEntries();
    return SignOption_STANDARD_instance;
  }
  function SignOption_ALWAYS_SIGNED_getInstance() {
    SignOption_initEntries();
    return SignOption_ALWAYS_SIGNED_instance;
  }
  function SignOption_POSITIVE_ONLY_getInstance() {
    SignOption_initEntries();
    return SignOption_POSITIVE_ONLY_instance;
  }
  function SignOption_ACCOUNTING_getInstance() {
    SignOption_initEntries();
    return SignOption_ACCOUNTING_instance;
  }
  function SignOption_NONE_getInstance() {
    SignOption_initEntries();
    return SignOption_NONE_instance;
  }
  var TrailingZeroesBehavior_SHOW_NONE_instance;
  var TrailingZeroesBehavior_SHOW_ALL_instance;
  var TrailingZeroesBehavior_SHOW_TWO_instance;
  function values_2() {
    return [TrailingZeroesBehavior_SHOW_NONE_getInstance(), TrailingZeroesBehavior_SHOW_ALL_getInstance(), TrailingZeroesBehavior_SHOW_TWO_getInstance()];
  }
  function valueOf_2(value) {
    switch (value) {
      case 'SHOW_NONE':
        return TrailingZeroesBehavior_SHOW_NONE_getInstance();
      case 'SHOW_ALL':
        return TrailingZeroesBehavior_SHOW_ALL_getInstance();
      case 'SHOW_TWO':
        return TrailingZeroesBehavior_SHOW_TWO_getInstance();
      default:
        TrailingZeroesBehavior_initEntries();
        THROW_ISE();
        break;
    }
  }
  var TrailingZeroesBehavior_entriesInitialized;
  function TrailingZeroesBehavior_initEntries() {
    if (TrailingZeroesBehavior_entriesInitialized)
      return Unit_getInstance();
    TrailingZeroesBehavior_entriesInitialized = true;
    TrailingZeroesBehavior_SHOW_NONE_instance = new TrailingZeroesBehavior('SHOW_NONE', 0);
    TrailingZeroesBehavior_SHOW_ALL_instance = new TrailingZeroesBehavior('SHOW_ALL', 1);
    TrailingZeroesBehavior_SHOW_TWO_instance = new TrailingZeroesBehavior('SHOW_TWO', 2);
  }
  function TrailingZeroesBehavior(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function TrailingZeroesBehavior_SHOW_NONE_getInstance() {
    TrailingZeroesBehavior_initEntries();
    return TrailingZeroesBehavior_SHOW_NONE_instance;
  }
  function TrailingZeroesBehavior_SHOW_ALL_getInstance() {
    TrailingZeroesBehavior_initEntries();
    return TrailingZeroesBehavior_SHOW_ALL_instance;
  }
  function TrailingZeroesBehavior_SHOW_TWO_getInstance() {
    TrailingZeroesBehavior_initEntries();
    return TrailingZeroesBehavior_SHOW_TWO_instance;
  }
  var UnitMagnitudeFormat_ABBREVIATED_instance;
  var UnitMagnitudeFormat_FULL_instance;
  function values_3() {
    return [UnitMagnitudeFormat_ABBREVIATED_getInstance(), UnitMagnitudeFormat_FULL_getInstance()];
  }
  function valueOf_3(value) {
    switch (value) {
      case 'ABBREVIATED':
        return UnitMagnitudeFormat_ABBREVIATED_getInstance();
      case 'FULL':
        return UnitMagnitudeFormat_FULL_getInstance();
      default:
        UnitMagnitudeFormat_initEntries();
        THROW_ISE();
        break;
    }
  }
  var UnitMagnitudeFormat_entriesInitialized;
  function UnitMagnitudeFormat_initEntries() {
    if (UnitMagnitudeFormat_entriesInitialized)
      return Unit_getInstance();
    UnitMagnitudeFormat_entriesInitialized = true;
    UnitMagnitudeFormat_ABBREVIATED_instance = new UnitMagnitudeFormat('ABBREVIATED', 0);
    UnitMagnitudeFormat_FULL_instance = new UnitMagnitudeFormat('FULL', 1);
  }
  function UnitMagnitudeFormat(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function UnitMagnitudeFormat_ABBREVIATED_getInstance() {
    UnitMagnitudeFormat_initEntries();
    return UnitMagnitudeFormat_ABBREVIATED_instance;
  }
  function UnitMagnitudeFormat_FULL_getInstance() {
    UnitMagnitudeFormat_initEntries();
    return UnitMagnitudeFormat_FULL_instance;
  }
  var ZeroBiasOption_NONE_instance;
  var ZeroBiasOption_NEGATIVE_instance;
  var ZeroBiasOption_POSITIVE_instance;
  function values_4() {
    return [ZeroBiasOption_NONE_getInstance(), ZeroBiasOption_NEGATIVE_getInstance(), ZeroBiasOption_POSITIVE_getInstance()];
  }
  function valueOf_4(value) {
    switch (value) {
      case 'NONE':
        return ZeroBiasOption_NONE_getInstance();
      case 'NEGATIVE':
        return ZeroBiasOption_NEGATIVE_getInstance();
      case 'POSITIVE':
        return ZeroBiasOption_POSITIVE_getInstance();
      default:
        ZeroBiasOption_initEntries();
        THROW_ISE();
        break;
    }
  }
  var ZeroBiasOption_entriesInitialized;
  function ZeroBiasOption_initEntries() {
    if (ZeroBiasOption_entriesInitialized)
      return Unit_getInstance();
    ZeroBiasOption_entriesInitialized = true;
    ZeroBiasOption_NONE_instance = new ZeroBiasOption('NONE', 0);
    ZeroBiasOption_NEGATIVE_instance = new ZeroBiasOption('NEGATIVE', 1);
    ZeroBiasOption_POSITIVE_instance = new ZeroBiasOption('POSITIVE', 2);
  }
  function ZeroBiasOption(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ZeroBiasOption_NONE_getInstance() {
    ZeroBiasOption_initEntries();
    return ZeroBiasOption_NONE_instance;
  }
  function ZeroBiasOption_NEGATIVE_getInstance() {
    ZeroBiasOption_initEntries();
    return ZeroBiasOption_NEGATIVE_instance;
  }
  function ZeroBiasOption_POSITIVE_getInstance() {
    ZeroBiasOption_initEntries();
    return ZeroBiasOption_POSITIVE_instance;
  }
  //region block: post-declaration
  defineProp(protoOf(CurrencyRepresentationOption), 'name', protoOf(CurrencyRepresentationOption).q6, VOID);
  defineProp(protoOf(CurrencyRepresentationOption), 'ordinal', protoOf(CurrencyRepresentationOption).r6, VOID);
  defineProp(protoOf(RoundingMode), 'name', protoOf(RoundingMode).q6, VOID);
  defineProp(protoOf(RoundingMode), 'ordinal', protoOf(RoundingMode).r6, VOID);
  defineProp(protoOf(SignOption), 'name', protoOf(SignOption).q6, VOID);
  defineProp(protoOf(SignOption), 'ordinal', protoOf(SignOption).r6, VOID);
  defineProp(protoOf(TrailingZeroesBehavior), 'name', protoOf(TrailingZeroesBehavior).q6, VOID);
  defineProp(protoOf(TrailingZeroesBehavior), 'ordinal', protoOf(TrailingZeroesBehavior).r6, VOID);
  defineProp(protoOf(UnitMagnitudeFormat), 'name', protoOf(UnitMagnitudeFormat).q6, VOID);
  defineProp(protoOf(UnitMagnitudeFormat), 'ordinal', protoOf(UnitMagnitudeFormat).r6, VOID);
  defineProp(protoOf(ZeroBiasOption), 'name', protoOf(ZeroBiasOption).q6, VOID);
  defineProp(protoOf(ZeroBiasOption), 'ordinal', protoOf(ZeroBiasOption).r6, VOID);
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.CurrencyRepresentationOption = CurrencyRepresentationOption;
    $com$squareup$cash$common$moneyformatter.CurrencyRepresentationOption.values = values;
    $com$squareup$cash$common$moneyformatter.CurrencyRepresentationOption.valueOf = valueOf;
    defineProp($com$squareup$cash$common$moneyformatter.CurrencyRepresentationOption, 'NARROW_SYMBOL', CurrencyRepresentationOption_NARROW_SYMBOL_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.CurrencyRepresentationOption, 'CODE', CurrencyRepresentationOption_CODE_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.CurrencyRepresentationOption, 'NARROW_SYMBOL_AND_CODE', CurrencyRepresentationOption_NARROW_SYMBOL_AND_CODE_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.CurrencyRepresentationOption, 'CENT_NAME', CurrencyRepresentationOption_CENT_NAME_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.CurrencyRepresentationOption, 'NONE', CurrencyRepresentationOption_NONE_getInstance, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.DenominationOption = DenominationOption;
    defineProp($com$squareup$cash$common$moneyformatter.DenominationOption, 'Cents', Cents_getInstance, VOID);
    $com$squareup$cash$common$moneyformatter.DenominationOption.Dollars = Dollars;
    $com$squareup$cash$common$moneyformatter.DenominationOption.DollarsAndCents = DollarsAndCents;
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.FractionDigitsStrategy = FractionDigitsStrategy;
    defineProp($com$squareup$cash$common$moneyformatter.FractionDigitsStrategy, 'Companion', Companion_getInstance, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.MoneyFormatterConfig = MoneyFormatterConfig;
    defineProp($com$squareup$cash$common$moneyformatter.MoneyFormatterConfig, 'Companion', Companion_getInstance_0, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.NumberFormat = NumberFormat;
    defineProp($com$squareup$cash$common$moneyformatter.NumberFormat, 'Full', Full_getInstance, VOID);
    $com$squareup$cash$common$moneyformatter.NumberFormat.Abbreviated = Abbreviated;
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.RoundingMode = RoundingMode;
    $com$squareup$cash$common$moneyformatter.RoundingMode.values = values_0;
    $com$squareup$cash$common$moneyformatter.RoundingMode.valueOf = valueOf_0;
    defineProp($com$squareup$cash$common$moneyformatter.RoundingMode, 'UP', RoundingMode_UP_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.RoundingMode, 'DOWN', RoundingMode_DOWN_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.RoundingMode, 'CEILING', RoundingMode_CEILING_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.RoundingMode, 'FLOOR', RoundingMode_FLOOR_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.RoundingMode, 'HALF_UP', RoundingMode_HALF_UP_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.RoundingMode, 'HALF_DOWN', RoundingMode_HALF_DOWN_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.RoundingMode, 'HALF_EVEN', RoundingMode_HALF_EVEN_getInstance, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.SignOption = SignOption;
    $com$squareup$cash$common$moneyformatter.SignOption.values = values_1;
    $com$squareup$cash$common$moneyformatter.SignOption.valueOf = valueOf_1;
    defineProp($com$squareup$cash$common$moneyformatter.SignOption, 'STANDARD', SignOption_STANDARD_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.SignOption, 'ALWAYS_SIGNED', SignOption_ALWAYS_SIGNED_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.SignOption, 'POSITIVE_ONLY', SignOption_POSITIVE_ONLY_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.SignOption, 'ACCOUNTING', SignOption_ACCOUNTING_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.SignOption, 'NONE', SignOption_NONE_getInstance, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.TrailingZeroesBehavior = TrailingZeroesBehavior;
    $com$squareup$cash$common$moneyformatter.TrailingZeroesBehavior.values = values_2;
    $com$squareup$cash$common$moneyformatter.TrailingZeroesBehavior.valueOf = valueOf_2;
    defineProp($com$squareup$cash$common$moneyformatter.TrailingZeroesBehavior, 'SHOW_NONE', TrailingZeroesBehavior_SHOW_NONE_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.TrailingZeroesBehavior, 'SHOW_ALL', TrailingZeroesBehavior_SHOW_ALL_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.TrailingZeroesBehavior, 'SHOW_TWO', TrailingZeroesBehavior_SHOW_TWO_getInstance, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.UnitMagnitudeFormat = UnitMagnitudeFormat;
    $com$squareup$cash$common$moneyformatter.UnitMagnitudeFormat.values = values_3;
    $com$squareup$cash$common$moneyformatter.UnitMagnitudeFormat.valueOf = valueOf_3;
    defineProp($com$squareup$cash$common$moneyformatter.UnitMagnitudeFormat, 'ABBREVIATED', UnitMagnitudeFormat_ABBREVIATED_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.UnitMagnitudeFormat, 'FULL', UnitMagnitudeFormat_FULL_getInstance, VOID);
    var $com = _.com || (_.com = {});
    var $com$squareup = $com.squareup || ($com.squareup = {});
    var $com$squareup$cash = $com$squareup.cash || ($com$squareup.cash = {});
    var $com$squareup$cash$common = $com$squareup$cash.common || ($com$squareup$cash.common = {});
    var $com$squareup$cash$common$moneyformatter = $com$squareup$cash$common.moneyformatter || ($com$squareup$cash$common.moneyformatter = {});
    $com$squareup$cash$common$moneyformatter.ZeroBiasOption = ZeroBiasOption;
    $com$squareup$cash$common$moneyformatter.ZeroBiasOption.values = values_4;
    $com$squareup$cash$common$moneyformatter.ZeroBiasOption.valueOf = valueOf_4;
    defineProp($com$squareup$cash$common$moneyformatter.ZeroBiasOption, 'NONE', ZeroBiasOption_NONE_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.ZeroBiasOption, 'NEGATIVE', ZeroBiasOption_NEGATIVE_getInstance, VOID);
    defineProp($com$squareup$cash$common$moneyformatter.ZeroBiasOption, 'POSITIVE', ZeroBiasOption_POSITIVE_getInstance, VOID);
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = Cents;
  _.$_$.b = DollarsAndCents;
  _.$_$.c = Dollars;
  _.$_$.d = MoneyFormatterConfig;
  _.$_$.e = Abbreviated;
  _.$_$.f = Full;
  _.$_$.g = RoundingMode_HALF_UP_getInstance;
  _.$_$.h = SignOption_ACCOUNTING_getInstance;
  _.$_$.i = TrailingZeroesBehavior_SHOW_ALL_getInstance;
  _.$_$.j = TrailingZeroesBehavior_SHOW_NONE_getInstance;
  _.$_$.k = TrailingZeroesBehavior_SHOW_TWO_getInstance;
  _.$_$.l = Cents_getInstance;
  _.$_$.m = Companion_getInstance_0;
  //endregion
  return _;
}(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js')));

